import { Box, Grid, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
const BoxPadded = styled(Box)(({ theme }) => ({
    // padding: '14px 20px',
    width: '100%',
}));

const SideBarNav = props => {
    const LinkStyle = styled(IconButton)(({ theme }) => ({
        color: '#FFFEFE',
        textDecoration: 'none',
        fontSize: props.size,
        display: 'inline-block',
        width: 220,
        padding: '10px 20px',
        margin: '0px 10px 0px 0px',
        borderRadius: '0px 30px 30px 0px',
        textAlign: 'left',
        verticalAlign: 'middle',
        '&:hover': {
            color: '#4632DA',
            textDecoration: 'none',
            background: '#FFFEFE',
        },
    }));

    return (
        <Grid item md={12} lg={12}>
            <BoxPadded>
                <LinkStyle
                    component={Link}
                    tag={RouterNavLink}
                    to={props.link}
                    exact
                >
                    {props.icon}
                    {props.linkname}
                </LinkStyle>
            </BoxPadded>
        </Grid>
    );
};

export default SideBarNav;
